import { Component, OnInit, ViewChild } from '@angular/core';
import { SrubUpService } from '../Services/ScrubUp.service';
import { CookieService } from 'ngx-cookie-service';
import { AppWideUser, Token } from '../Services/AppUserProfile';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs';
import { MatSort, Sort, MatTableModule, MatSortModule } from '@angular/material';
import { LiveAnnouncer } from '@angular/cdk/a11y';
declare var $: any;
import { MatPaginator }
  from '@angular/material';
import 'rxjs/add/operator/map';
import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { Globals } from '../Models/UserProfile.model';
import { MyContactsDTO } from '../Models/Contact.model';
import { Router } from '@angular/router';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import {DatePipe} from '@angular/common';

interface USER {
  Name: string;
  Email: string;
  RoleName: string;
  RoleCategory: string;
  RegisteredOn: string;
  LastLogin: string;
  EmailConfirmed: boolean;
}
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  providers: [SrubUpService, DatePipe],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class UserComponent implements OnInit {
  displayedColumns: string[] = [
    'Name',
    'Email',
    'RoleName',
    'RoleCategory',
    'RegisteredOn',
    'SubscriptionPlan',
    'InitialPurchaseDate',
    'NextRenewalDate',
    'LastLogin',
    'Action'
  ];
  platforms = [
    { value: '', label: 'All' },
    { value: 'Android', label: 'Android' },
    { value: 'iOS', label: 'iOS' }
  ];
  packageTypes = [
    { value: '0', label: 'All' },
    { value: '1', label: 'Freemium' },
    { value: '2', label: 'Tier 1' },
    { value: '3', label: 'Tier 2' }
  ];
  workplaceTypeList = [
    { value: '', label: 'All' },
    { value: '1', label: 'Public' },
    { value: '2', label: 'Private' },
    { value: '3', label: 'Other' }
  ];
  dataSource: eDataSource;
  ELEMENT_DATA: USER[] = [];
  public loading = false;
  searchUser = '';
  searchUsertxt: string;
  roles: any = [];
  data: any = [];
  selectedRowIndex: any;
  loginUserId: number;
  totalRecords = 0;
  pagesize = 10;
  showMyContainerflag = false;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  row: any;
  pageLength = 100;
  pageSize = 2;
  searchvisi: number;
  invite: number;
  searchUserDetails: Array<MyContactsDTO>;
  isImpersonateMode: boolean;
  toImpersonateUserId: number;
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  workplaceType = '';
  subscriptionPlan = '';
  initialPurchaseDate = '';
  nextRenewalDate = '';
  role = '';
  fromDate = '';
  toDate = '';
  plateFormType = '';
  packageType = '0';

  constructor(private _liveAnnouncer: LiveAnnouncer, private scrubUpService: SrubUpService, private cookieService: CookieService, private appUser: AppWideUser, private token: Token, private appUserDetails: AppWideUser, private router: Router, private datePipe: DatePipe) {
    this.searchvisi = 0;
    this.invite = 0;
    if (this.appUser.UserName == undefined && this.token.access_token == undefined || this.appUser.UserName == null && this.token.access_token == null) {

      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUser = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }
    this.loginUserId = this.appUser.UserId;

  }

  ngOnInit() {
    this.getUserDetails();
    this.getDefaultDesignationRoleMasterList();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
  }

  formatDate(event: any, type: string) {
    const formattedDate = this.datePipe.transform(event, 'yyyy-MM-dd');
    if (type === 'from') {
      this.fromDate = formattedDate;
    } else {
      this.toDate = formattedDate;
    }
  }

  ImpersonateUser(user: any) {
    if (user.EmailConfirmed) {
      this.scrubUpService.impersonateLogin(user.Email, this.cookieService.get("sup-access-token")).subscribe(x => {
        if (x.userName != null && x.access_token != null) {
          this.loading = false;
          this.searchUserDetails = x;
          this.searchvisi = 1;
          this.invite = 0;
          this.cookieService.delete('Token');
          this.token.access_token = x.access_token;
          this.cookieService.set('accessToken', this.token.access_token);
          this.token.userName = x.userName;
          this.token.expires = x.expires;
          this.token.expires_in = x.expires_in;
          this.token.issued = x.issued;
          this.token.token_type = x.token_type;
          this.toImpersonateUserId = user.UserProfileID;
          this.appUserDetails.UserId = this.toImpersonateUserId;
          this.cookieService.set('userId', this.appUserDetails.UserId.toString());

          this.cookieService.set('Token', JSON.stringify(this.token));
          this.cookieService.set('super-access-token', this.token.access_token);
          this.cookieService.set('access-token', this.token.access_token);

          Globals.ImpersonationValue = true;
          this.cookieService.set('impersonation', 'true');
          this.loading = false;
          this.router.navigateByUrl('sidebar', { skipLocationChange: true }).then(() =>
            this.router.navigate(['layout/user-speciality']));

        }
        this.loading = false;
      },
        error => {
          this.loading = false;
        });
    } else {
      console.log('ImpersonateUser not confirmed');

    }
  }

  GetSearchUsersContactInfo(goClicked: boolean = false) {
    this.loading = true;
    this.data = [];

    let pageindex = 0;

    if (this.paginator.pageIndex == 0 || goClicked) {
      pageindex = 0;
      this.paginator.pageIndex = 0;
    }
    else {
      pageindex = this.paginator.pageIndex;
    }

    this.scrubUpService.GetSearchUserDetails(
      this.token,
      this.loginUserId,
      pageindex, 10,
      this.searchUser,
      this.workplaceType,
      this.plateFormType,
      this.packageType,
      this.role,
      this.fromDate,
      this.toDate
    ).subscribe(x => {
        if (x != null && x != undefined) {
          this.loading = false;
          this.data = x['Data']['AdminReportsUsers'];
          this.dataSource = new eDataSource(this.data);
          this.totalRecords = x['Data']['totalRecords'];
          this.searchvisi = 1;
          this.invite = 0;
          this.searchUsertxt = this.searchUser;
          this.announceSortChange(this.sort);
        }
        this.loading = false;
      },
      error => {
        this.loading = false;
      });
  }

  highlight(row) {
    this.selectedRowIndex = row.RoleName;
  }
  showMyContainer(row, index) {
    this.row = [];
    this.row = row;
    this.showMyContainerflag = true;

  }
  getUserDetails() {
    this.loading = true;
    this.data = [];

    let pageindex = 0;
    if (this.paginator.pageIndex == 0) {
      pageindex = 0;
    }
    else {
      pageindex = this.paginator.pageIndex;
    }

    this.scrubUpService.getUserReportDetails(this.token, pageindex, 10).subscribe(x => {
      if (x['Data'] != null && x['Status'] == true && x['Data'].AdminReportsUsers.length > 0) {
        this.data = x['Data']['AdminReportsUsers'];
        this.dataSource = new eDataSource(this.data);
        this.totalRecords = x['Data']['totalRecords'];
        this.pagesize = 10;

      }
      this.loading = false;

    },
      error => {
        this.loading = false;
      });
  }
  getDefaultDesignationRoleMasterList() {
    this.loading = true;
    this.roles = [];
    this.roles = [{
      'DesignationRoleID' : '',
      'DesignationRoleName': 'All'
    }];

    this.scrubUpService.getDefaultDesignationRoleMasterList(this.token, this.loginUserId).subscribe(x => {
      if (x['Data'] != null && x['Status'] == true && x['Data'].length > 0) {
        if(this.roles.length > 0){
          this.roles = this.roles.concat(x['Data']);
        } else {
          this.roles = x['Data'];
        }
      }
      this.loading = false;

    },
      error => {
        this.loading = false;
      });
  }

  displayDetail() {
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction == 'asc') {
      this.data.sort((a, b) => a[sortState.active] > b[sortState.active] ? 1 : a[sortState.active] < b[sortState.active] ? -1 : 0);
      return this.dataSource = new eDataSource(this.data);
    } else {
      this.data.sort((a, b) => a[sortState.active] < b[sortState.active] ? 1 : a[sortState.active] > b[sortState.active] ? -1 : 0);
      return this.dataSource = new eDataSource(this.data);
    }
  }

  //use for pagination
  ngAfterViewInit() {
     // Using direct reference to avoid production build issues
     const merged = Observable.merge(this.sort.sortChange, this.paginator.page);
     merged.subscribe(() => {
       this.GetSearchUsersContactInfo();
     });
   }
}

export class eDataSource extends DataSource<any> {
  constructor(private element: Element[]) {
    super();
  }
  paginator: any;
  connect(): Observable<Element[]> {
    return Observable.of(this.element);
  }

  disconnect() { }

}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/users/user.component.ts